import React, { useState, useEffect } from "react";
import cx from "classnames";
import * as Search from "@elevio/kb-kit/lib/components/search";
import { useLanguages } from "@elevio/kb-kit/lib/hooks";
import { bannerUrl } from "../pages/home";
import { Logo } from "./Logo";
import LoginLogout from "./LoginLogout";
import LanguagePicker from "./LanguagePicker";
import MetaTags from "react-meta-tags";
function Header({ children, className, hideSearch, breadcrumbs }) {
    const [displaySearchBar] = useState(false);
    const { supportedLanguages, selectedLanguage, setCurrentLanguageId } = useLanguages();
    const isMobile = () => {
        return (navigator.userAgent.match(/Android/i) != null ||
            navigator.userAgent.match(/iPhone/i) != null);
    };
    useEffect(() => {
        const script = document.createElement("script");
        if (isMobile()) {
            script.src =
                "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            document.body.appendChild(script);
            const script2 = document.createElement("script");
            script2.innerHTML = ` function googleTranslateElementInit() {
        new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element_mobile');
       } `;
            document.body.appendChild(script2);
            script.async = true;
        }
        else {
            script.src =
                "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            const script3 = document.createElement("script");
            script3.innerHTML = ` function googleTranslateElementInit() {
      new google.translate.TranslateElement({
        pageLanguage: 'en',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        autoDisplay: false
      }, 'google_translate_element'); } `;
            document.body.appendChild(script3);
        }
        document.body.appendChild(script);
    }, []);
    return (<div id="wrapper" className="wrapper">
      <MetaTags>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
      </MetaTags>

      <header className={cx("header", "header-bg-color", "header-text-color", className)} data-testid="header">
        <div id="header-wrapper" className="header-wrapper">
          <nav className="nav" aria-label="navigation">
            <div id="nav-wrapper" className="nav-wrapper">
              <div id="nav-details" className="nav-details">
                <Logo />
              </div>

              <div id="nav-desktop-menu" className="nav-desktop-menu">
                <div id="request-submission-container" className="request-submission-container">
                  <a className="nav-desktop-menu-link" href="https://agency.comcate.com/private-submission/listing?crm_token=5oe00emr75q&auth_enabled=true&logout_redirect_url=https%3A%2F%2Fbozeman.comcate.com%2Fen" target="_blank" rel="noopener noreferrer">
                    <div id="request-link" className="request-link">
                      <svg className="request-link-logo" height="100px" width="100px" fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve">
                        <g>
                          <path d="M4.3,68.6l18.3,2.9V28.6L4.3,31.4V68.6z M8.7,35.2l9.6-1.5v32.7l-9.6-1.5V35.2z M77.8,28.6v42.9l17.9-2.9   V31.4L77.8,28.6z M91.3,64.8l-9.2,1.5V33.7l9.2,1.5V64.8z M26.4,83.5h47.3V16.5H26.4V83.5z M30.7,20.9h38.6v58.2H30.7V20.9z"/>
                        </g>
                      </svg>
                      <span className="request-link-text">
                        <div id="View-Your-Submissions" className="request-link-label">Login to Account</div>
                      </span>
                    </div>
                  </a>
                </div>
                <div id="google_translate_element"></div>
                <LoginLogout className="nav-desktop-menu-link"/>
                {supportedLanguages.length > 1 && (<LanguagePicker selectedLanguageId={selectedLanguage.id} setCurrentLanguageId={setCurrentLanguageId} supportedLanguages={supportedLanguages}/>)}
              </div>
            </div>
          </nav>

          <div id="mobile-menu" className="mobile-menu">
            <div id="mobile-menu-wrapper" className="mobile-menu-wrapper">
              <div id="request-submission-container" className="request-submission-container">
                <a className="nav-desktop-menu-link mobile-menu-link" href="https://agency.comcate.com/private-submission/listing?crm_token=5oe00emr75q&auth_enabled=true&logout_redirect_url=https%3A%2F%2Fbozeman.comcate.com%2Fen" target="_blank" rel="noopener noreferrer">
                  <div id="request-link-1" className="request-link">
                    <svg className="request-link-logo" height="100px" width="100px" fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve">
                      <g>
                        <path d="M4.3,68.6l18.3,2.9V28.6L4.3,31.4V68.6z M8.7,35.2l9.6-1.5v32.7l-9.6-1.5V35.2z M77.8,28.6v42.9l17.9-2.9   V31.4L77.8,28.6z M91.3,64.8l-9.2,1.5V33.7l9.2,1.5V64.8z M26.4,83.5h47.3V16.5H26.4V83.5z M30.7,20.9h38.6v58.2H30.7V20.9z"/>
                      </g>
                    </svg>
                    <span className="request-link-text">
                      <div id="View-Your-Submissions-1" className="request-link-label">Login to Account</div>
                    </span>
                  </div>
                </a>
                <div id="google-translate-button-1" className="google-translate-button">
                  <div id="google_translate_element_mobile"></div>
                </div>
              </div>
              <LoginLogout className="mobile-menu-link"/>
              {supportedLanguages.length > 1 && (<LanguagePicker selectedLanguageId={selectedLanguage.id} setCurrentLanguageId={setCurrentLanguageId} supportedLanguages={supportedLanguages}/>)}
            </div>
          </div>

          {displaySearchBar && !hideSearch && (<div id="mobile-search" className="mobile-search">
              <div id="mobile-search-wrapper" className="mobile-search-wrapper">
                <Search.Input className="mobile-search-input"/>
              </div>
            </div>)}

          {children && (<div id="hero" className="hero" style={{ backgroundImage: `url(${bannerUrl})` }}>
              <div className="hero-wrapper" id="hero-wrapper">
                {children}
              </div>
            </div>)}
          {breadcrumbs}
        </div>
      </header>
    </div>);
}
export default Header;
